<template>
  <div class="type_list" :class="{ loading }">
    <div class="loading_spinner">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <ElTooltip :content="statusMessage">
      <div class="status" :class="status"></div>
    </ElTooltip>
    <div class="title">На ваших складах</div>
    <div class="value" v-for="value of values" :title="value.notification.text">
      <i
        class="fas fa-info-circle"
        :style="`color: ${value.notification.color}`"
      ></i>
      <span class="hide_on_hover"> {{ value.warehouse.name }}:</span>
      {{ value.notification.text }}
    </div>
    <div v-if="values.length == 0 && !loading">Всё отлично 👍</div>
  </div>
</template>

<script>
let apiDriver = require("../../apiDriver").default;
let moment = require("moment");
import { Tooltip } from "element-ui";

export default {
  name: "service_11_problems",
  components: {
    [Tooltip.name]: Tooltip,
  },
  data: function () {
    return {
      loading: true,
      values: [],
      status: "",
      statusMessage: "",
    };
  },
  methods: {
    declOfNum: function (number, titles) {
      var cases = [2, 0, 1, 1, 1, 2];
      return titles[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : cases[number % 10 < 5 ? number % 10 : 5]
      ];
    },
    getData: async function () {
      this.loading = true;
      let warehouses = (
        await apiDriver.services.api.get("inventory", "store/list", {
          notifications: true,
        })
      ).data.list.filter((x) => x.notifications.length != 0);
      let notifications = [];
      for (let warehouse of warehouses) {
        for (let n of warehouse.notifications) {
          notifications.push({
            notification: n,
            warehouse: warehouse,
          });
        }
      }
      console.log("notifications:", notifications);
      this.values = notifications.splice(0, 3);
      if (this.values.length == 0) {
        this.status = "green";
        this.statusMessage = "Проблемы не обнаружены";
      } else {
        this.status = "orange";
        this.statusMessage = `На некоторых складах обнаружены проблемы`;
      }
      this.loading = false;
    },
  },
  mounted: function () {
    this.getData();
  },
};
</script>